import React, { useState } from 'react';
import { X, Lock, Save } from 'lucide-react';
import api from '../utils/api';

export default function ChangePasswordModal({ onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (newPassword.length < 6) {
      setError('Mật khẩu mới cần tối thiểu 6 ký tự.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Xác nhận mật khẩu chưa khớp.');
      return;
    }

    setLoading(true);
    try {
      const data = await api.changePassword(currentPassword, newPassword);
      setMessage(data.message || 'Đổi mật khẩu thành công.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">Đổi mật khẩu</div>
          <button className="btn-icon" onClick={onClose} type="button"><X size={18} /></button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body stack-gap-md">
            {error && <div className="alert alert-error">{error}</div>}
            {message && <div className="alert alert-success">{message}</div>}

            <div className="form-group">
              <label className="form-label">Mật khẩu hiện tại</label>
              <div className="input-icon-wrap">
                <Lock size={16} />
                <input className="form-input with-icon" type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Mật khẩu mới</label>
              <div className="input-icon-wrap">
                <Lock size={16} />
                <input className="form-input with-icon" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Xác nhận mật khẩu mới</label>
              <div className="input-icon-wrap">
                <Lock size={16} />
                <input className="form-input with-icon" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-ghost" type="button" onClick={onClose}>Đóng</button>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              <Save size={15} /> {loading ? 'Đang lưu...' : 'Lưu mật khẩu'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
